module.exports = __webpack_public_path__ + "Flag-158.98a5dbaa58e2c196bb9a22bd4f834519.svg";